/**
 * Stock inventory catalog CRUD
 */
import { apiClient } from './baseApi';

const BASE = '/miter/production-performance/stock-inventory-items';

export const stockInventoryItemsService = {
  listCatalog: async (params = {}) => {
    const response = await apiClient.get(`${BASE}/catalog`, { params });
    return response.data;
  },

  listColumns: async () => {
    const response = await apiClient.get(`${BASE}/columns`);
    return response.data;
  },

  addColumn: async (name) => {
    const response = await apiClient.post(`${BASE}/columns`, { name });
    return response.data;
  },

  createItem: async (payload) => {
    const response = await apiClient.post(BASE, payload);
    return response.data;
  },

  updateItem: async (id, payload) => {
    const response = await apiClient.put(`${BASE}/${id}`, payload);
    return response.data;
  },

  deleteItem: async (id) => {
    const response = await apiClient.delete(`${BASE}/${id}`);
    return response.data;
  },

  renameExtraField: async (from, to) => {
    const response = await apiClient.post(`${BASE}/extra-fields/rename`, { from, to });
    return response.data;
  },

  deleteExtraField: async (key) => {
    const response = await apiClient.post(`${BASE}/extra-fields/delete`, { key });
    return response.data;
  },
};
